import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {documentTypes, genders, provinces} from "../../../shared/types/custom-types";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {EventFilterModel} from "../../../shared/model/request/event-filter.model";

@Component({
    selector: 'app-filterevent',
    templateUrl: './filterevent.component.html',
    standalone: false
})
export class FilterEventComponent implements OnInit, OnChanges {

  @Input('categoryChangeEvent') categoryChangeEvent: boolean;
  @Input('category') category?: string
  @Output('filters') filtersSubmissionEvent = new EventEmitter<EventFilterModel>()
  @Output() categorySelected = new EventEmitter<string>()

  readonly provinces: { code: string, description: string }[] = provinces()
  readonly categories: { code: string, description: string }[] = [
    {code: 'PEOPLE', description: 'Pessoas'},
    {code: 'DOCUMENT', description: 'Documentos'},
    {code: 'VEHICLE', description: 'Veículos'},
    {code: 'OTHER', description: 'Diversos'},
  ]
  readonly intents: { code: string, description: string }[] = [
    {code: '', description: ''},
    {code: 'SEEKING', description: 'À procura'},
    {code: 'FOUND', description: 'Encontrado'},
  ]
  readonly genders: { code: string, description: string }[] = genders()
  readonly documentType: { code: string, description: string }[] = documentTypes()
  readonly eventMaxDate: Date = new Date()

  form: FormGroup

  constructor() {
  }

  ngOnInit(): void {
    this.initForm()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['category'] || !this.form) {
      return
    }
    this.form.reset()
    this.form.get('category').setValue(this.category)
  }

  initForm(): void {
    this.form = new FormGroup({
      "category": new FormControl(null),
      "intent": new FormControl(null),
      "reference": new FormControl(null),
      "title": new FormControl(null),
      "gender": new FormControl(null),
      "identification": new FormControl(null),
      "minAge": new FormControl(null, Validators.min(0)),
      "maxAge": new FormControl(null, Validators.min(0)),

      "documentType": new FormControl(null),
      "documentEntity": new FormControl(null),

      "brand": new FormControl(null),
      "model": new FormControl(null),
      "licensePlate": new FormControl(null),
      "chassiNumber": new FormControl(null),

      "eventDate": new FormControl(null),
      "province": new FormControl(null),
    })

    this.form.get('category').setValue(this.category)

  }

  submitForm() {
    this.filtersSubmissionEvent.emit(this.form.value)
  }

  selectCategory(selected: string) {
    if (!selected || selected === this.category) {
      return
    }
    this.category = selected
    this.form.get('category').setValue(selected)
    this.categorySelected.emit(selected)
  }

  onClear() {
    this.form.reset()
    this.form.get('category').setValue(this.category)
  }
}
